import { useEffect, useState } from "react";

export function StatusBar(): React.JSX.Element {
  const [time, setTime] = useState(() =>
    new Date().toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" }),
  );

  useEffect(() => {
    const t = setInterval(() => {
      setTime(new Date().toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" }));
    }, 30_000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="h-[44px] shrink-0 bg-moss flex items-center justify-between px-5 md:hidden">
      <span className="font-body font-semibold text-[13px] text-white">{time}</span>
      <div className="flex items-center gap-1.5">
        {/* Signal bars */}
        <svg width="16" height="12" viewBox="0 0 16 12" fill="white" opacity="0.9" aria-hidden="true">
          <rect x="0" y="8" width="3" height="4" rx="1" />
          <rect x="4.5" y="5" width="3" height="7" rx="1" />
          <rect x="9" y="2" width="3" height="10" rx="1" />
          <rect x="13.5" y="0" width="2.5" height="12" rx="1" />
        </svg>
        {/* Battery */}
        <svg width="22" height="11" viewBox="0 0 22 11" fill="none" aria-hidden="true">
          <rect x="0.5" y="0.5" width="18" height="10" rx="2.5" stroke="white" strokeOpacity="0.9" />
          <rect x="2" y="2" width="13" height="7" rx="1.5" fill="white" />
          <path d="M20 3.5v4c.83-.5 1.5-1.17 1.5-2s-.67-1.5-1.5-2z" fill="white" fillOpacity="0.6" />
        </svg>
      </div>
    </div>
  );
}
